module.exports = __webpack_public_path__ + "static/img/2.9608206.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/2.png
// module id = AO06
// module chunks = 0